import "./IntelligentAutomation.css";
import { Link } from "react-router-dom";

const IntelligentAutomation = () => {
  return (
    <section className="ia-section">
      <div className="container">
        <h2 className="ia-heading">Our AI & RPA Consulting Services</h2>

        <div className="row g-4">
          {/* Strategy */}
          <div className="col-lg-6">
            <Link to="/RPA-AI-Strategy" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <div className="ia-icon text-center bulb-container">
                    <i className="bi bi-lightbulb-fill bulb-main"></i>

                    {/* Rays */}
                    <span className="ray ray-top"></span>
                    <span className="ray ray-top-left"></span>
                    <span className="ray ray-top-right"></span>
                    <span className="ray ray-left"></span>
                    <span className="ray ray-right"></span>
                  </div>
                </div>
                <h3>Strategy</h3>

                <p>
                  We evaluate your organization’s digital maturity and develop a
                  strategic automation roadmap aligned with your business goals.
                </p>
                <a href="/RPA-AI-Strategy">Strategy Services →</a>
              </div>
            </Link>
          </div>

          {/* Implementation */}
          <div className="col-lg-6">
            <Link to="/RPA-AI-Implementation" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <i className="bi bi-gear"></i>
                </div>
                <h3>Implementation</h3>

                <p>
                  We partner with you across your automation journey, from POCs
                  and pilots to full-scale enterprise deployment.
                </p>
                <a href="/RPA-AI-Implementation">Implementation Services →</a>
              </div>
            </Link>
          </div>

          {/* Center of Excellence */}
          <div className="col-lg-6">
            <Link to="/RPA-AI-Coe" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <i className="bi bi-award"></i>
                </div>
                <h3>Center of Excellence</h3>

                <p>
                  Scale automation enterprise-wide with a governance model that
                  unifies people, processes, and technology.
                </p>
                <a href="/RPA-AI-Coe">CoE Development →</a>
              </div>
            </Link>
          </div>

          {/* Support & Maintenance */}
          <div className="col-lg-6">
            <Link to="/RPA-AI-Support" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <i className="bi bi-tools"></i>
                </div>
                <h3>Support & Maintenance</h3>

                <p>
                  Flexible support delivered through managed services, ongoing
                  administrative support, and continuous automation
                  enhancements.
                </p>
                <a href="/RPA-AI-Support">Support & Maintenance →</a>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntelligentAutomation;
